export const coursesPathSuffix = '/courses';

// note: relative paths cause issues with creator hub navigation
export const coursesRootPath = `/docs${coursesPathSuffix}`;
export const coursesAbsolutePath = `https://create.roblox.com${coursesRootPath}`;

export const coursesNavTabKey = 'Courses';
